export default __webpack_public_path__ + "static/media/1.9652d8d6.png";